const prefix = 'access-form-draft:';
export function draftKey(companyId, form, record = 'new') {
  const token = localStorage.getItem('token') || 'anonymous';
  let owner = 0;
  for (const c of token) owner = Math.imul(owner, 31) + c.charCodeAt(0) | 0;
  return `${prefix}${owner}:${companyId}:${form}:${record}`;
}
export function readDraft(key) {
  try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch { return null; }
}
export function writeDraft(key, value) {
  try { sessionStorage.setItem(key, JSON.stringify(value)); return true; } catch { return false; }
}
export function removeDraft(key) { try { sessionStorage.removeItem(key); } catch {} }
export function clearSessionDrafts() {
  try { Object.keys(sessionStorage).filter(k => k.startsWith(prefix)).forEach(removeDraft); } catch {}
}
